export const JOB_TITLES = [
  'Administration',
  'Analytics',
  'Assistant Site Leader',
  'Cashier',
  'Construction & Installation',
  'Engineering & Equipment',
  'Field Operations',
  'Finance & Accounting',
  'Franchise Development',
  'Franchise Owner',
  'Fulfillment & Logistics',
  'General Manager',
  'Human Resources',
  'IT & Software',
  'Key Holder',
  'Leadership',
  'Maintenance',
  'Marketing',
  'Production',
  'Real Estate',
  'Sales Associate',
  'Shift Lead',
  'Site Leader',
  'Team Member',
  'Training & Development',
  'Wash Technician',
];

// Job title used to be free text, so existing employees may have a value outside the list.
// Keep their saved value as an option so it still displays and passes validation.
export const getJobTitleOptions = (savedTitle?: string): string[] =>
  savedTitle && !JOB_TITLES.includes(savedTitle) ? [savedTitle, ...JOB_TITLES] : JOB_TITLES;
